import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type { ProviderCapability, PublicAnalyticsRefreshStatus } from "../../../shared/types";
import { api } from "../lib/api";

const refreshKey = (brandId: string) => ["analytics-refresh", brandId] as const;

export function useAnalyticsRefresh(brandId: string) {
  return useQuery({
    queryKey: refreshKey(brandId),
    queryFn: () => api.get<{ data: PublicAnalyticsRefreshStatus[] }>(`/api/brands/${encodeURIComponent(brandId)}/analytics/refresh`),
    enabled: !!brandId,
    refetchInterval: 30_000,
  });
}

export function useSetAnalyticsRefresh(brandId: string, assignmentId: string, capability: ProviderCapability) {
  const client = useQueryClient();
  return useMutation({
    mutationFn: (enabled: boolean) => api.patch<{ data: PublicAnalyticsRefreshStatus }>(
      `/api/brands/${encodeURIComponent(brandId)}/analytics/refresh/${encodeURIComponent(assignmentId)}`,
      { capability, enabled },
    ),
    // Use the captured brand scope, never the newly selected source's cache.
    onSuccess: async () => { await client.invalidateQueries({ queryKey: refreshKey(brandId) }); },
  });
}
